export default __webpack_public_path__ + "static/media/app.bf56af24.svg";